

import { gUtilityLocalStorage } from "../utility/UtilityLocalStorage";

    export const  gAccount = {
        m_token:null,//
        Account_shopid:null,//
        Account_shop:null,//
        parseProtocal : function(data)
        {
            this.m_token = data.token;
            sessionStorage.setItem("m_token", this.m_token);
        },

        get_token : function()
        {
            if (null == this.m_token)
            {
                this.m_token = sessionStorage.getItem("m_token");
            }
            return this.m_token;
        },
        ser_Account_shopid : function(data)
        {
          this.Account_shopid = data;
          sessionStorage.setItem("Account_shopid", this.Account_shopid);
        },
        get_Account_shopid : function()
        {
            if (null == this.Account_shopid)
            {
                this.Account_shopid = sessionStorage.getItem("Account_shopid");
            }
            return this.Account_shopid;
        },

        ser_Account_shop : function(data)
        {
          this.Account_shop = data;
          sessionStorage.setItem("Account_shop", this.Account_shop);
        },
        get_Account_shop : function()
        {
            if (null == this.Account_shop)
            {
                this.Account_shop = sessionStorage.getItem("Account_shop");
            }
            return JSON.parse(this.Account_shop);
        },


    };



// WEBPACK FOOTER //
// ./src/assets/js/data/Account.js